module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_3_ES-07b6f9b49c908dd7501242ee6f611758.svg";